module.exports = {
      id: "d57eb53127ed9331e2bb7b51dbd7333atoiletEquipment-classic-toilet.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#d57eb53127ed9331e2bb7b51dbd7333atoiletEquipment-classic-toilet.svg",
      toString: function () {
        return this.url;
      }
    }